import { IContentDataImage } from "../../interfaces/IContentData";
import { ISiteModuleImageGallery, ISiteModuleImageGalleryItem } from "../../interfaces/ISiteModule";
import { randomId } from "../../utils/Random";
import { getNewSiteModuleBasic } from "./getNewSiteModuleBasic";

export const getNewSiteModuleImageGallery = (): ISiteModuleImageGallery => {
    return {
        siteModuleType: "ImageGallery",
        ...getNewSiteModuleBasic(false),
        title: {
            contentDataType: "Title",
            text: {},
        },
        text: {
            contentDataType: "RichText",
            richText: {},
        },
        gallery: [],
    };
};

export const getNewSiteModuleImageGalleryItem = (image: IContentDataImage): ISiteModuleImageGalleryItem => {
    return {
        id: "CLIENTID-LIST-ITEM" + randomId(),
        image,
    };
};
